export const getWrapperStyles = () => ({
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: '#12151D',
	width: '100%',
});

export const getContentWrapperStyles = {
	maxWidth: '1920px',
	width: '100%',
	justifyContent: 'center',
	alignItems: 'center',
	padding: {
		xs: '1.375rem 1.25rem 1rem 1.25rem',
		md: '2.5rem 2% 2.125rem 2%',
		lg: '2.5rem 5% 1rem 5%',
	},
};

export const getFooterWrapperStyles = {
	display: 'flex',
	width: '100%',
	height: { xs: '100%', md: '26.063rem' }, // Set height for the footer
	flexDirection: 'column', // Stack vertically on small, horizontally on medium and up
	alignItems: 'flex-start', // Align items to the top
	mb: { xs: 4, md: 6 }, // Margin bottom for the top section
	gap: { xs: 4, md: 1 }, // Gap between main columns (increased for more middle space)
}

export const getFirstRowStyles = {
	width: { xs: '100%', md: '100%' },
	display: 'flex', // Make this Box a flex container
	flexDirection: { xs: 'column', md: 'row' }, // Stack its children vertically
	justifyContent: 'space-between',
}

export const getSecondRowStyles = {
	flexShrink: 0,
	width: { xs: '100%', md: '100%' },
	display: 'flex', // Make this Box a flex container
	flexDirection: { xs: 'column', md: 'row' }, // Stack its children vertically
	justifyContent: 'space-between',
}

export const getThirdRowStyles = {
	flexShrink: 0,
	width: { xs: '100%', md: '100%' },
	display: 'flex', // Make this Box a flex container
	flexDirection: { xs: 'column', md: 'row' }, // Stack its children vertically
	justifyContent: 'space-between',
	marginTop: 'auto', // Push this section to the bottom
}


export const getAboutWrapperStyles = {
	display: 'flex',
	paddingLeft: '0px',
	'@media (min-width: 600px)': {
		paddingLeft: '0px',
	},
};

export const copyrightStyles = {
	textAlign: { xs: 'left', md: 'center' },
	justifyContent: 'left',
	display: 'flex',
	marginTop: 'auto',
	fontSize: '12px',
};

export const getSocialNetworkImageStyles = (isLightFooter?: boolean) => ({
	width: '2.188rem',
	height: '2.188rem',
	...(isLightFooter && {
		filter: 'brightness(0) saturate(100%) invert(15%) sepia(53%) saturate(4016%) hue-rotate(208deg) brightness(93%) contrast(112%)',
	}),
});

export const breadCrumbsAndTopBtnContainerStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	paddingX: { xs: '1.75rem', md: '2%', lg: '5%' },
	paddingTop: { xs: '1rem', md: '1.25rem' },
	paddingBottom: { xs: '.75rem', md: '.5rem' },
};

export const breadCrumbsAndTopBtnContainerFooterLiteStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	paddingBottom: { xs: '1rem', md: '2rem' },
};

export const breadCrumbsContainerStyles = {
	alignItems: 'center',
	maxWidth: '80%',
};

export const getPolicyGroupStyle = {
	display: 'flex',
	flexFlow: 'row no-wrap',
	justifyContent: 'flex-start',
	gap: '3.5rem',
};

export const policyLinkStyles = {
	justifyContent: 'flex-start',
	lineHeight: '16px',
	fontFamily: 'Messina Sans',
	fontWeight: 350,
	fontSize: '.75rem',
};
